module.exports = __webpack_public_path__ + "media/images/marathi-matrimony-banner-60477e9e25bb3bdd44ec52c2750d8ed9.jpg";